import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

function Unauthorized() {

    const dispatch = useDispatch();

    return (
        <React.Fragment>
            <div class="container">
            <div class="error-page d-flex flex-column flex-lg-row align-items-center justify-content-center h-screen text-center text-lg-start">
                <div class="-intro-x me-lg-20">
                    <img alt="Error image" class="h-48 h-lg-auto" src="/images/garage-logo.png" />
                </div>
                <div class="text-white mt-10 mt-lg-0">
                    <div class="intro-x fs-8xl fw-medium">404</div>
                    <div class="intro-x fs-xl fs-lg-3xl fw-medium mt-5">Oops. This page has gone missing.</div>
                    <div class="intro-x fs-lg mt-3">You may have mistyped the address or the page may have moved.</div>
                    <Link to="/" class="intro-x btn py-3 px-4 text-white border-white dark-border-dark-5 dark-text-gray-300 mt-10">Back to Home</Link>
                </div>
            </div>
        </div>
        </React.Fragment>
    )
}

export default Unauthorized;